import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import * as wq from '@packages/systems/wfdl-Qualified';
import {forall, a, tyfun, func, $} from '@packages/utilities/wfdl-helpers';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {LogicLabel} from '@packages/systems/flows/shared';

const id = wq.identifier;

const tyOption = wast.TTypeConstructor(
  wq.qualify(wq.pluginName('Option'), wq.typeName('Option'))
);

export const TOption = (arg: w.Type): w.Type =>
  wast.TTypeApplication({
    con: tyOption,
    arg,
  });

export const plugin = w.Plugins.PrivilegedPlugin({
  dataTypes: {
    WithFallbackLabel: w.TypeImplementation.Alias({
      params: ['a'],
      system: {bindUIVariant: 'custom'},
      type: a,
      render: function RenderFallbackLabel({expr, dispatch}) {
        return (
          <>
            <LogicLabel label="Fallback" />
            <ExpressionEditor expression={expr} dispatch={dispatch} />
          </>
        );
      },
    }),

    Option: w.TypeImplementation.Alias({
      params: ['a'],
      icon: w.TypeImplementation.IconFromType(wast.TTypeReference('a')),
      type: wast.TUnion({
        None: wast.TEmptyRecord,
        Some: wast.TTypeReference('a'),
      }),
      render: ({expr, dispatch}) => (
        <ExpressionEditor dispatch={dispatch} expression={expr} />
      ),
    }),
  },
  values: {
    Some: {
      envType: {
        dataType: forall(['a'], wast.functionOf(a, TOption(a))),
        exported: 'visible',
        implicit: 'prefilledArgs',
      },
      expression: wast.EFunction({
        param: 'value',
        body: wast.EUnion({
          tag: 'Some',
          value: $('value'),
        }),
      }),
    },

    None: {
      envType: {
        dataType: forall(['a'], TOption(a)),
        exported: 'hidden',
      },
      expression: wast.EUnion({
        tag: 'None',
        value: wast.ERecord({}),
      }),
    },

    'From Option': {
      envType: {
        dataType: forall(
          ['a'],
          tyfun(
            [
              wast.TTypeApplication({
                con: wast.TTypeConstructor(
                  wq.qualify(
                    wq.pluginName('Option'),
                    wq.typeName('WithFallbackLabel')
                  )
                ),
                arg: a,
              }),
              TOption(a),
            ],
            a
          )
        ),
        exported: 'visible',
        implicit: 'prefilledArgs',
      },

      expression: func(
        [id('fallback'), id('option')],
        wast.ECase({
          value: $('option'),
          cases: {
            Some: func([id('value')], $('value')),
            None: func([id('_')], $('fallback')),
          },
        })
      ),
    },
  },
});
